import axios from "axios";

export default {
  dashboard(query = {}) {
    return axios
      .get("/api/commercial-dashboard", {
        params: query
      })
      .catch(error => error.response);
  },
  eventRegistrations() {
    return axios
      .get("/api/commercial-dashboard/event-registrations")
      .catch(error => error.response);
  },
  eventRegistrants(eventIds) {
    return axios
      .get("/api/commercial-dashboard/event-registrations/registrants", {
        params: { event_ids: eventIds }
      })
      .catch(error => error.response);
  },
  commercials(query = {}) {
    return axios
      .get("/api/commercial-dashboard/commercials", {
        params: query
      })
      .catch(error => error.response);
  },
  myRelancesDetail(query = {}) {
    return axios
      .get("/api/commercial-dashboard/my-relances/detail", {
        params: query
      })
      .catch(error => error.response);
  },
  drilldowns(query = {}) {
    return axios
      .get("/api/commercial-dashboard/drilldowns", {
        params: query
      })
      .catch(error => error.response);
  },
  drilldownItem(applicationId, query = {}) {
    return axios
      .get("/api/commercial-dashboard/drilldowns/" + applicationId, {
        params: query
      })
      .catch(error => error.response);
  },
  focusSettings() {
    return axios
      .get("/api/commercial-dashboard/focus-settings")
      .catch(error => error.response);
  },
  updateFocusSettings(data) {
    return axios
      .put("/api/commercial-dashboard/focus-settings", data)
      .catch(error => error.response);
  },
  heartbeat() {
    return axios
      .post("/api/candidate/heartbeat")
      .catch(error => error.response);
  }
};
